module.exports = __webpack_public_path__ + "static/media/Radiant_diamonds.7fa46b70.jpg";